export const Local = {
  TOKEN: 'ac_t',
  REFRESH_TOKEN: 'rfr_t',
  USER: 'u_i',
};

export const QUERY_MIN_LENGTH = 2;
